<template>
  <!-- 人工分配的对话框 -->
  <el-dialog
    center
    width="600px"
    title="人工分配"
    :visible.sync="dialogFormVisible"
    @closed="closed"
  >
    <el-form :model="changeForm" :rules="changeRules" ref="changeForm">
      <el-form-item
        label="销售员姓名"
        :label-width="formLabelWidth"
        prop="salesmanName"
      >
        <el-select
          class="select"
          v-model="changeForm.salesmanName"
          filterable
          remote
          placeholder="请输入销售员名字"
          :remote-method="searchUser"
          @change="checkItem"
          clearable
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="客服姓名"
        :label-width="formLabelWidth"
        prop="servicePersonName"
      >
        <el-select
          class="select"
          v-model="changeForm.servicePersonName"
          filterable
          remote
          placeholder="请输入客服姓名"
          :remote-method="searchUser"
          @change="checkServicePerson"
          clearable
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="意见"
        :label-width="formLabelWidth"
        placeholder="请输入"
        prop="opinion"
      >
        <el-input v-model="changeForm.opinion" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { changeStatusApi } from '@/api/introduce';
import { getUserModelApi } from '@/api/user.js';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'manualAllocation',
  data() {
    return {
      formLabelWidth: '100px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      // 表单
      changeForm: {
        salesmanName: '',
        servicePersonName: '',
        opinion: '',
      },
      loading: false,
      options: [],
      // 表单的验证规则
      changeRules: {
        salesmanName: [
          { required: true, message: '销售员姓名不能为空！', trigger: 'blur' },
        ],
        servicePersonName: [
          { required: true, message: '客服姓名不能为空！', trigger: 'blur' },
          // { required: true, pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/, message: '手机号码格式错误'}
        ],
        opinion: [
          { required: true, message: '意见不能为空！', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    // ...mapGetters(['pickerOptions'])
  },
  watch: {},
  methods: {
    // 提交按钮
    submitEdit() {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let data =
        'appRecordId=' +
        this.changeForm.appRecordId +
        '&salesmanName=' +
        this.changeForm.salesmanName +
        '&servicePersonName=' +
        this.changeForm.servicePersonName +
        '&opinion=' +
        this.changeForm.opinion +
        '&areaId=' +
        areaId;
      // let data = {
      //   appRecordId: this.changeForm.appRecordId,
      //   salesmanName:this.changeForm.salesmanName,
      //   servicePersonName:this.changeForm.servicePersonName
      // }

      try {
        this.$refs.changeForm.validate(async (valid) => {
          if (!valid) return;
          await changeStatusApi('toManualAssignment', data).then((res) => {
            this.res1 = res;
            // /api/Introduce/toManualAssignment
          });
          if (this.res1.code === 200) {
            this.$message.success('变更成功！');
            this.dialogFormVisible = false;
            this.$refs.changeForm.resetFields();
            this.$emit('fetchData');
          }
        });
      } catch (e) {
        // window.console.log(e)
      }
    },
    // 关闭时的回调
    closed() {
      this.$refs.changeForm.resetFields();
    },
    // 搜索用户名
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择用户名下拉选项
    checkItem(val) {
      this.changeForm.salesmanName = val;
    },
    // 选择客户下拉选项
    checkServicePerson(val) {
      this.changeForm.servicePersonName = val;
    },
  },
  created() {},
};
</script>

<style lang="less" scoped></style>
